import styled from 'styled-components';
import { theme } from '../../../../theme';

export const DivSection = styled.div`
  margin-bottom: 0.923rem;

  & > div:first-child {
    margin-top: 1.846rem;
  }
`;

export const DivTitle = styled.div`
  margin: 0 0 2.307rem 3.077rem;
  padding-bottom: 0.615rem;
  font-size: 1.154rem;
  font-weight: 600;
  color: ${theme.colors.secondary};
  border-bottom: 1px solid ${theme.colors.secondary};
`;

export const DivContent = styled.div`
  margin: 0 3.077rem;
  display: flex;
  flex-direction: column;

  ${theme.up(theme.breakpoints.sm)} {
    margin: 0 6.154rem 0 3.077rem;
  }

  ${theme.up(theme.breakpoints.lg)} {
    flex-direction: row;
    justify-content: space-between;
  }
`;
